export const inverseMarketTickerMap: Record<string, string> = {
    'PRES-2024-DJT': 'PRES-2024-KH',
    'SENATEWI-24-R': 'SENATEWI-24-D',
    'SENATETX-24-R': 'SENATETX-24-D',
    'SENATEPA-24-R': 'SENATEPA-24-D',
    'SENATEOH-24-R': 'SENATEOH-24-D',
    'SENATENV-24-R': 'SENATENV-24-D',
    'SENATENE-24-R': 'SENATENE-24-D',
    'SENATEMT-24-R': 'SENATEMT-24-D',
    'SENATEMI-24-R': 'SENATEMI-24-D',
    'SENATEMD-24-R': 'SENATEMD-24-D',
    'SENATEFL-24-R': 'SENATEFL-24-D',
    'SENATEAZ-24-R': 'SENATEAZ-24-D',
    'PRESPARTYWI-24-R': 'PRESPARTYWI-24-D',
    'PRESPARTYPA-24-R': 'PRESPARTYPA-24-D',
    'PRESPARTYNV-24-R': 'PRESPARTYNV-24-D',
    'PRESPARTYNC-24-R': 'PRESPARTYNC-24-D',
    'PRESPARTYMI-24-R': 'PRESPARTYMI-24-D',
    'PRESPARTYGA-24-R': 'PRESPARTYGA-24-D',
    'PRESPARTYAZ-24-R': 'PRESPARTYAZ-24-D',
    'POPVOTE-24-R': 'POPVOTE-24-D',
};

export const inverseMarketTicker = (ticker: string): string | null => {
    // Margin of victory markets don't have inverse prices
    if (ticker.includes('MOV')) return null;

    if (ticker === 'KXUCL16RMAMCI-25-RMA') return 'KXUCL16RMAMCI-25-MCI';

    if (ticker === 'KXAFC-25-KC') return 'KXAFC-25-BUF';
    if (ticker === 'KXNFC-25-PHI') return 'KXNFC-25-WAS';

    if (ticker === 'KXSB-25-PHI') {
        return 'KXSB-25-KC';
    }

    if (ticker === 'KXUEFACL-25-PSG') {
        return 'KXUEFACL-25-IM';
    }

    const seriesTicker = ticker.split('-')[0];
    if (
        ['POPVOTE', 'PRES', 'CONTROL', 'CONTROLH', 'CONTROLS'].includes(seriesTicker) ||
        seriesTicker.includes('PRESPARTY') ||
        seriesTicker.includes('SENATE')
    ) {
        const finalTwoChars = ticker.slice(-2);
        if (finalTwoChars == '-I') {
            return ticker.slice(0, -2) + '-R';
        }

        if (finalTwoChars == '-R' && seriesTicker !== 'SENATENE') {
            return ticker.slice(0, -2) + '-D';
        }

        const finalFourChars = ticker.slice(-4);
        if (finalFourChars == '-DJT') {
            return ticker.slice(0, -4) + '-KH';
        }
    }

    return null;
};
